export const PublicOffer = '/files/public-offer.pdf';


// WEBPACK FOOTER //
// ./src/utils/files.js